var map = {
	"./ar.svg": "./src/Asset/flags/ar.svg",
	"./flag_are.png": "./src/Asset/flags/flag_are.png",
	"./flag_arg.png": "./src/Asset/flags/flag_arg.png",
	"./flag_aus.png": "./src/Asset/flags/flag_aus.png",
	"./flag_ban.png": "./src/Asset/flags/flag_ban.png",
	"./flag_bel.png": "./src/Asset/flags/flag_bel.png",
	"./flag_bhr.png": "./src/Asset/flags/flag_bhr.png",
	"./flag_bra.png": "./src/Asset/flags/flag_bra.png",
	"./flag_can.png": "./src/Asset/flags/flag_can.png",
	"./flag_chl.png": "./src/Asset/flags/flag_chl.png",
	"./flag_chn.png": "./src/Asset/flags/flag_chn.png",
	"./flag_civ.png": "./src/Asset/flags/flag_civ.png",
	"./flag_col.png": "./src/Asset/flags/flag_col.png",
	"./flag_dji.png": "./src/Asset/flags/flag_dji.png",
	"./flag_dnk.png": "./src/Asset/flags/flag_dnk.png",
	"./flag_due.png": "./src/Asset/flags/flag_due.png",
	"./flag_dza.png": "./src/Asset/flags/flag_dza.png",
	"./flag_ecu.png": "./src/Asset/flags/flag_ecu.png",
	"./flag_egy.png": "./src/Asset/flags/flag_egy.png",
	"./flag_esp.png": "./src/Asset/flags/flag_esp.png",
	"./flag_eth.png": "./src/Asset/flags/flag_eth.png",
	"./flag_fin.png": "./src/Asset/flags/flag_fin.png",
	"./flag_fra.png": "./src/Asset/flags/flag_fra.png",
	"./flag_gbr.png": "./src/Asset/flags/flag_gbr.png",
	"./flag_gha.png": "./src/Asset/flags/flag_gha.png",
	"./flag_grc.png": "./src/Asset/flags/flag_grc.png",
	"./flag_idn.png": "./src/Asset/flags/flag_idn.png",
	"./flag_ind.png": "./src/Asset/flags/flag_ind.png",
	"./flag_irn.png": "./src/Asset/flags/flag_irn.png",
	"./flag_irq.png": "./src/Asset/flags/flag_irq.png",
	"./flag_ita.png": "./src/Asset/flags/flag_ita.png",
	"./flag_jpn.png": "./src/Asset/flags/flag_jpn.png",
	"./flag_ken.png": "./src/Asset/flags/flag_ken.png",
	"./flag_kor.png": "./src/Asset/flags/flag_kor.png",
	"./flag_kwt.png": "./src/Asset/flags/flag_kwt.png",
	"./flag_lbr.png": "./src/Asset/flags/flag_lbr.png",
	"./flag_lka.png": "./src/Asset/flags/flag_lka.png",
	"./flag_mex.png": "./src/Asset/flags/flag_mex.png",
	"./flag_mys.png": "./src/Asset/flags/flag_mys.png",
	"./flag_nam.png": "./src/Asset/flags/flag_nam.png",
	"./flag_nga.png": "./src/Asset/flags/flag_nga.png",
	"./flag_nld.png": "./src/Asset/flags/flag_nld.png",
	"./flag_nor.png": "./src/Asset/flags/flag_nor.png",
	"./flag_omn.png": "./src/Asset/flags/flag_omn.png",
	"./flag_pak.png": "./src/Asset/flags/flag_pak.png",
	"./flag_pan.png": "./src/Asset/flags/flag_pan.png",
	"./flag_per.png": "./src/Asset/flags/flag_per.png",
	"./flag_phl.png": "./src/Asset/flags/flag_phl.png",
	"./flag_pry.png": "./src/Asset/flags/flag_pry.png",
	"./flag_qat.png": "./src/Asset/flags/flag_qat.png",
	"./flag_sau.png": "./src/Asset/flags/flag_sau.png",
	"./flag_sgp.png": "./src/Asset/flags/flag_sgp.png",
	"./flag_tha.png": "./src/Asset/flags/flag_tha.png",
	"./flag_tur.png": "./src/Asset/flags/flag_tur.png",
	"./flag_twn.png": "./src/Asset/flags/flag_twn.png",
	"./flag_uga.png": "./src/Asset/flags/flag_uga.png",
	"./flag_ury.png": "./src/Asset/flags/flag_ury.png",
	"./flag_usa.png": "./src/Asset/flags/flag_usa.png",
	"./flag_ven.png": "./src/Asset/flags/flag_ven.png",
	"./flag_vnm.png": "./src/Asset/flags/flag_vnm.png",
	"./in.svg": "./src/Asset/flags/in.svg",
	"./ke.svg": "./src/Asset/flags/ke.svg",
	"./lk.svg": "./src/Asset/flags/lk.svg",
	"./pk.svg": "./src/Asset/flags/pk.svg",
	"./us.svg": "./src/Asset/flags/us.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Asset/flags sync recursive ^\\.\\/.*$";